import { useCallback, useMemo, useState } from "react";

const useGnenrateColor = () => {

    const Randomcolor = useCallback((id :any) => {

        //const [range, setRange] = useState(10);
        //const [saturation, setSaturation] = useState(75);
        //const [lightness, setLightness] = useState(50);
        const range = 10 ; 
        const saturation = 75;
        const lightness = 50;

        const getRange = (value: any, range: any) => {
            return [Math.max(0, value - range), Math.min(value + range, 100)];
        }

        const saturationRange = getRange(saturation, range);
        const lightnessRange = getRange(lightness, range);

        const getHashOfString = (str: any) => {
            let hash = 0;
            for (let i = 0; i < str.length; i++) {
                // tslint:disable-next-line: no-bitwise
                hash = str.charCodeAt(i) + ((hash << 5) - hash);
            }
            hash = Math.abs(hash);
            return hash;
        };

        const normalizeHash = (hash: any, min: any, max: any) => {
            return Math.floor((hash % (max - min)) + min);
        };

        const generateHSL = (name: any/* , saturationRange: any, lightnessRange: any */) => {
            const hash = getHashOfString(name);
            const h = normalizeHash(hash, 0, 360);
            const s = normalizeHash(hash, saturationRange[0], saturationRange[1]);
            const l = normalizeHash(hash, lightnessRange[0], lightnessRange[1]);
            return [h, s, l];
        };

        const HSLtoString = (hsl: any) => {
            return `hsl(${hsl[0]}, ${hsl[1]}%, ${hsl[2]}%)`;
        };

        const generateColorHsl = (id: any/* , saturationRange: any, lightnessRange: any */) => {
            return HSLtoString(generateHSL(id/* , saturationRange, lightnessRange */));
        };

        return HSLtoString(generateHSL(id));

    }, [])

    return [Randomcolor];
}

export default useGnenrateColor; 